<!-- Venue Travel Info and Attractions -->
<div class="container my-5">
    <h2 class="text-center mt-5 mb-4">Places to Visit</h2>

    <div>
        <h4 class="text-center">Near the wedding mahal</h4>
        <div class="card shadow-sm mb-3">
            <div class="card-header bg-light fw-bold">
                Within the city
            </div>
            <ul class="list-group list-group-flush">
                <li class="list-group-item">Medhai Police Station – Old Fort</li>
                <li class="list-group-item">District Science Centre</li>
                <li class="list-group-item">Government Museum</li>
                <li class="list-group-item">Pothigai Nagar Park</li>
                <li class="list-group-item">Adichanallur Archaeological Site</li>
                <li class="list-group-item">Manjapancholai Dam</li>
                <li class="list-group-item">Tamirabharani River</li>
            </ul>
        </div>

        <div class="card shadow-sm">
            <div class="card-header bg-light fw-bold">
                Within 50 km
            </div>
            <ul class="list-group list-group-flush">
                <li class="list-group-item">Theri Kaadu – Red Sand Desert</li>
                <li class="list-group-item">Mundanthurai Tiger Reserve</li>
                <li class="list-group-item">Manimutharu Dam</li>
                <li class="list-group-item">Manimutharu Waterfalls</li>
                <li class="list-group-item">
                    Manjolai <span class="text-muted">(requires special permission from govt officials)</span>
                </li>
                <li class="list-group-item">Courtallam Waterfalls</li>
            </ul>
        </div>
    </div>

</div>